import type { ParentComponent } from 'solid-js'
import { css } from 'styled-system/css'

export const PlaceCenter: ParentComponent = (props) => {
	return (
		<div
			class={css({
				position: 'absolute',
				width: '100%',
				height: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			})}
		>
			{props.children}
		</div>
	)
}
